export default {
  'Choose File': 'Escolher Arquivo',
  'Please paste a URL': 'Por favor, cole um URL',
  'Loading': 'Carregando',
  'Analyzing': 'Analisando',
  'Try a sample': 'Experimente uma amostra',
  'Sorry, error occurs when analyzing the URL.': 'Desculpe, ocorreu um erro ao analisar o URL.',
  'Upload a photo': 'Carregar uma foto',
  "Drag and drop files to the upload box.": 'Arrastar e soltar os arquivos na caixa de upload.',
  'Please select the proper position with portrait.': 'Por favor, selecione a posição apropriada com retrato.',
  'downloading': 'baixando',
}